var map = {
	"./bergahorn.png": 42771,
	"./birke.png": 11271,
	"./buche.png": 22625,
	"./esche.png": 42878,
	"./hainbuche.png": 26773,
	"./platane.png": 61717,
	"./robinie.png": 89808,
	"./rosskastanie.png": 83863,
	"./schwarzpappel.png": 3561,
	"./spitzahorn.png": 87527,
	"./stieleiche.png": 24654,
	"./winterlinde.png": 22586
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98164;